import styles from './WelcomeHero.module.css';

function WelcomeHero() {
    return (
        <section className={styles.hero} data-screen-label="Welcome hero">
            <div className={styles.heroInner}>
                <div className={styles.heroText}>
                    <h1 className={styles.title}>It's in your hands. Your <span className={styles.grad}>journey</span> starts now.</h1>
                    <p className={styles.heroSub2}>Follow your clinician's instructions for your first dose, and keep an eye out for your first check-in. In the meantime, here are a few things worth a few minutes today.</p>
                </div>
            </div>
        </section>
    );
}

export default WelcomeHero;
